import React, { useMemo, useState, useEffect } from 'react';

import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ContactSupportBanner from './components/ContactSupportBanner';
import FigmaCardBox from './components/FigmaCardBox';
import MyAgentsToolbar from './components/MyAgentsToolbar';
import OpportunityOverviewBanner from './components/OpportunityOverviewBanner';
import SectionDivider from './components/SectionDivider';
import { emptyCardsState, gridContainer, gridItem, pageShell, spacing } from './OpportunityWorkspace.style';
import {
    DEFAULT_MY_AGENTS_TOOLBAR,
    DEFAULT_NO_SEARCH_RESULTS,
    filterOpportunityCardsByQuery,
} from './utils';
import { PUBLIC_PATH } from '../../constants';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
    getContractDataById, clearSuccessMsg, getDataModelById, getModelDataDropDown, initiateAction, updateDataModelData, getMembersList, clearReduxDataOfCurrentComponent, getModelData, getGroupsByMemberId, getNextRespondent, getDataModels, createOpportunity, getAllOpportunities, deleteOpportunity, getSingleOpportunity, updateOpportunity, createActionForOpportunity, getAllActionsOfOpportunity, getSingleActionOfOpportunity, updateSingleActionOfOpportunity, deleteSingleActionOfOpportunity, getDocumentsFromIDsOfOpportunity, uploadAttachmentOpportunity, deleteAttachmentsForOpportunity, downloadContractPDFAction, getWorkflowById, getNextTasks, executeWorkFlow, executeWorkFlowReject, createTaskForObligations, getAllTaskofobligation, getSingleTaskofobligation, initiateworkFlowObligations, changeAssigneeRequest, updateSingleTaskofobligation, getFirstStepMembers, acceptWorkFlowObligations, deleteTaskofobligation, currentStepMembersForobligation,
    rejectedWorkFlowObligations, addComment, getAuditTrailsData, completedWorkFlowObligations, getContractHierarchys, downloadSheet, getSpendDetails, getSpendFilters, globalAuditTrailsData, lastUpdatedDocumentId
} from '../../store/actions';

const OpportunityWorkspace = (props) => {
    const { members, data } = props;
    const { chartData, chartUniqueId } = data;
    const {
        cardsDetails,
        description,
        selectedDataModel,
        noCardsDescription,
        isOpportunityOverviewBannerEnabled,
        isSectionDividerEnabled,
        isCardsDetailsEnabled,
        isContactSupportBannerEnabled,
        isMyAgentsToolbarEnabled,
        myAgentsToolbarTitle = DEFAULT_MY_AGENTS_TOOLBAR.title,
        myAgentsSearchPlaceholder = DEFAULT_MY_AGENTS_TOOLBAR.searchPlaceholder,
        noSearchResultsDescription = DEFAULT_NO_SEARCH_RESULTS,
    } = chartData;

    const [cardSearchQuery, setCardSearchQuery] = useState('');
    const filteredCards = useMemo(
        () => filterOpportunityCardsByQuery(cardsDetails, cardSearchQuery),
        [cardsDetails, cardSearchQuery]
    );
    const hasSourceCards = Array.isArray(cardsDetails) && cardsDetails.length > 0;
    const searchIsActive = cardSearchQuery.trim().length > 0;

    const theme = useTheme();
    const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
    const pageShellStyle = useMemo(
        () => ({
            ...pageShell,
            ...(isLgDown ? { paddingLeft: 16, paddingRight: 16 } : {}),
        }),
        [isLgDown]
    );

    useEffect(() => {
        const payload = {
            appId: props.appId,
            orgId: props.orgId,
            dataModelId: chartData?.selectedDataModel,
            dataUniqueId: `${chartUniqueId}_last_updated_document_id`
          };
        props.lastUpdatedDocumentId(payload);
    }, []);

    console.log("filteredCards", filteredCards)

    return (
        <div style={pageShellStyle}>
            {
                isOpportunityOverviewBannerEnabled === true && <OpportunityOverviewBanner userName={members.name} subtitle={description} />
            }

            {
                isSectionDividerEnabled === true && <SectionDivider marginTop={spacing.sectionGap} marginBottom={spacing.sectionGap} />
            }

            {isCardsDetailsEnabled === true && (
                <MyAgentsToolbar
                    title={myAgentsToolbarTitle}
                    searchPlaceholder={myAgentsSearchPlaceholder}
                    onSearchChange={setCardSearchQuery}
                />
            )}

            {
                isCardsDetailsEnabled === true && <Grid container spacing={2} alignItems="stretch" style={gridContainer}>
                    {hasSourceCards ? (
                        filteredCards.length > 0 ? (
                            filteredCards.map((card) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={card.id} style={gridItem}>
                                    <FigmaCardBox
                                        eyebrow={card.eyebrow}
                                        title={card.title}
                                        description={card.description}
                                        buttonLabel={card.buttonLabel}
                                        isRouterLink={card.isRouterLink}
                                        routerLink={card.routerLink}
                                        isButton={card.isButton}
                                        appid={props.appId}
                                        chartUniqueId={chartUniqueId}
                                        formData={props.formData}
                                        isViewEnable={card.isViewEnable}
                                    />
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Typography component="p" style={emptyCardsState}>
                                    {searchIsActive
                                        ? noSearchResultsDescription
                                        : noCardsDescription ||
                                          'No opportunity shortcuts are available right now.'}
                                </Typography>
                            </Grid>
                        )
                    ) : (
                        <Grid item xs={12}>
                            <Typography component="p" style={emptyCardsState}>
                                {noCardsDescription || 'No opportunity shortcuts are available right now.'}
                            </Typography>
                        </Grid>
                    )}
                </Grid>

            }
            {
                isSectionDividerEnabled === true && <SectionDivider marginTop={spacing.sectionGap} marginBottom={0} />
            }

            {
                isContactSupportBannerEnabled === true && <ContactSupportBanner />
            }
        </div>
    )
};

const mapDispatchToProps = {
    getContractDataById,
    updateDataModelData,
    clearSuccessMsg,
    getModelDataDropDown,
    initiateAction,
    getMembersList,
    clearReduxDataOfCurrentComponent,
    getDataModelById,
    getModelData,
    getDataModels,
    getGroupsByMemberId,
    getNextRespondent,

    createOpportunity,
    getAllOpportunities,
    deleteOpportunity,
    getSingleOpportunity,
    updateOpportunity,
    createActionForOpportunity,
    getAllActionsOfOpportunity,
    getSingleActionOfOpportunity,
    updateSingleActionOfOpportunity,
    deleteSingleActionOfOpportunity,
    getDocumentsFromIDsOfOpportunity,
    uploadAttachmentOpportunity,
    deleteAttachmentsForOpportunity,
    downloadContractPDFAction,
    getWorkflowById,
    getNextTasks,
    executeWorkFlow,
    executeWorkFlowReject,
    createTaskForObligations,
    getAllTaskofobligation,
    getSingleTaskofobligation,
    initiateworkFlowObligations,
    changeAssigneeRequest,
    updateSingleTaskofobligation,
    getFirstStepMembers,
    acceptWorkFlowObligations,
    rejectedWorkFlowObligations,
    completedWorkFlowObligations,
    deleteTaskofobligation,
    currentStepMembersForobligation,
    addComment,
    getAuditTrailsData,
    getContractHierarchys,
    downloadSheet,
    getSpendDetails,
    getSpendFilters,
    globalAuditTrailsData,
    lastUpdatedDocumentId
};

const mapStateToProps = state => {
    return {
        formData: state.form,
        action: state.action,
        appConfig: state.appConfig.app,
        PUBLIC_PATH: PUBLIC_PATH,
        members: state.appConfig.members,
        dataModels: state.dataModels,
        user: state.user,
        appConfiguration: state.form.document?.appConfig
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OpportunityWorkspace));